(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vm-slideshow-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-slideshow')) {
    customElements.define('vm-slideshow', class extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.autoplayTimer = null;
        this.isHovered = false;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.touchEndX = 0;
        this.touchEndY = 0;
        this._onVisibility = this._onVisibility.bind(this);
        this._onPromoExpired = (event) => this.removeExpiredSlide(event.target.closest('.vm-slide'));
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.vm-slide'));
        this.dots = Array.from(this.querySelectorAll('.vm-slideshow-dot'));
        this.arrows = Array.from(this.querySelectorAll('.vm-slideshow-arrow'));
        this.track = this.querySelector('[data-track]');
        this.blockCount = parseInt(this.dataset.blockCount, 10) || this.slides.length;
        this.transition = this.dataset.transition || 'fade';
        this.loop = this.dataset.loop === 'true';
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplaySpeed = (parseFloat(this.dataset.autoplaySpeed) || 6) * 1000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.addEventListener('vm-rp:expired', this._onPromoExpired);
        this.slides.slice().forEach(slide => {
          if (slide.dataset.rpEnd && Date.parse(slide.dataset.rpEnd) <= Date.now()) this.removeExpiredSlide(slide);
        });
        this._setupReveal();

        if (this.blockCount <= 1) return;

        this.arrows.forEach((btn) => {
          btn.addEventListener('click', () => {
            if (btn.dataset.direction === 'next') this.next();
            else this.prev();
            this._resetAutoplay();
          });
        });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const idx = parseInt(dot.dataset.index, 10);
            this.goTo(idx);
            this._resetAutoplay();
          });
        });

        this.addEventListener('mouseenter', () => { this.isHovered = true; this.stopAutoplay(); });
        this.addEventListener('mouseleave', () => { this.isHovered = false; this.startAutoplay(); });
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => { queueMicrotask(() => this.startAutoplay()); });

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); this._resetAutoplay(); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); this._resetAutoplay(); }
        });

        this.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
          this.touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });

        this.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.touchEndY = e.changedTouches[0].screenY;
          const diffX = this.touchStartX - this.touchEndX;
          const diffY = this.touchStartY - this.touchEndY;
          if (Math.abs(diffY) > Math.abs(diffX)) return;
          if (Math.abs(diffX) > 50) {
            if (diffX > 0) this.next(); else this.prev();
            this._resetAutoplay();
          }
        }, { passive: true });

        document.addEventListener('visibilitychange', this._onVisibility);

        if (this.transition === 'slide') this._updateOffset();

        if (this.autoplay && !this.reducedMotion) this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        document.removeEventListener('visibilitychange', this._onVisibility);
        this.removeEventListener('vm-rp:expired', this._onPromoExpired);
      }

      removeExpiredSlide(slide) {
        const index = this.slides.indexOf(slide);
        if (index < 0) return;
        this.stopAutoplay();
        const active = document.activeElement;
        const removedDotFocused = this.dots[index] && this.dots[index].contains(active);
        const hiddenControlsFocused = this.blockCount <= 2 && [...this.dots, ...this.arrows].some(control => control.contains(active));
        if (slide.contains(active) || removedDotFocused || hiddenControlsFocused) this.focus({ preventScroll: true });
        slide.remove();
        if (this.dots[index]) this.dots[index].remove();
        this.slides.splice(index, 1);
        this.dots.splice(index, 1);
        this.blockCount = this.slides.length;
        this.slides.forEach((item, i) => { item.dataset.index = i; item.setAttribute('aria-label', `Slide ${i + 1} of ${this.blockCount}`); });
        this.dots.forEach((item, i) => { item.dataset.index = i; item.setAttribute('aria-label', `Go to slide ${i + 1}`); });
        this.arrows.forEach(item => { item.hidden = this.blockCount < 2; });
        const dots = this.querySelector('.vm-slideshow-dots');
        if (dots) dots.hidden = this.blockCount < 2;
        if (this.blockCount) this.goTo(Math.max(0, Math.min(this.currentIndex - (index < this.currentIndex ? 1 : 0), this.blockCount - 1)));
        else this.closest('.shopify-section').hidden = true;
        this.startAutoplay();
      }

      _onVisibility() {
        if (document.hidden) this.stopAutoplay();
        else if (this.autoplay && !this.reducedMotion && !this.isHovered) this.startAutoplay();
      }

      next() {
        let next = this.currentIndex + 1;
        if (next >= this.blockCount) {
          if (this.loop) next = 0;
          else return;
        }
        this.goTo(next);
      }

      prev() {
        let prev = this.currentIndex - 1;
        if (prev < 0) {
          if (this.loop) prev = this.blockCount - 1;
          else return;
        }
        this.goTo(prev);
      }

      goTo(index) {
        if (index < 0 || index >= this.blockCount) return;
        if (this.slides.some((slide, i) => i !== index && slide.contains(document.activeElement))) this.focus({ preventScroll: true });
        this.currentIndex = index;

        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
        });

        const newSlide = this.slides[index];
        if (newSlide && !newSlide.classList.contains('is-revealed')) {
          this._revealSlide(newSlide);
        }

        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (this.transition === 'slide') this._updateOffset();
      }

      _updateOffset() {
        if (!this.track) return;
        this.track.style.setProperty('--offset', `-${this.currentIndex * 100}%`);
      }

      startAutoplay() {
        if (!this.autoplay || this.reducedMotion || this.blockCount <= 1 || this.isHovered || document.hidden || this.contains(document.activeElement)) return;
        this.stopAutoplay();
        this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      _resetAutoplay() {
        if (this.autoplay && !this.reducedMotion && !this.isHovered) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      _setupReveal() {
        if (this.reducedMotion) {
          this.slides.forEach((s) => {
            s.classList.add('is-revealed');
            this._fillCounters(s);
          });
          return;
        }

        const firstSlide = this.slides[0];
        if (firstSlide) {
          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries, obs) => {
              entries.forEach((e) => {
                if (e.isIntersecting) {
                  this._revealSlide(e.target);
                  obs.unobserve(e.target);
                }
              });
            }, { threshold: 0.2 });
            io.observe(firstSlide);
          } else {
            this._revealSlide(firstSlide);
          }
        }
      }

      _revealSlide(slide) {
        slide.classList.add('is-revealed');
        const counters = slide.querySelectorAll('.vm-counter[data-target]');
        counters.forEach((c) => this._animateCounter(c));
      }

      _fillCounters(slide) {
        slide.querySelectorAll('.vm-counter[data-target]').forEach((c) => {
          c.textContent = c.dataset.target;
        });
      }

      _animateCounter(el) {
        if (el.dataset.played) return;
        el.dataset.played = '1';
        const target = parseInt(el.dataset.target, 10) || 0;
        const duration = Math.max(2000, Math.min(4500, target * 140));
        const startTime = performance.now() + 500;
        const ease = (t) => 1 - Math.pow(1 - t, 3);
        let lastVal = -1;
        const step = (now) => {
          if (now < startTime) { requestAnimationFrame(step); return; }
          const t = Math.min(1, (now - startTime) / duration);
          const val = Math.floor(target * ease(t));
          if (val !== lastVal) {
            el.textContent = val;
            el.classList.add('is-ticking');
            clearTimeout(el._tickTimer);
            el._tickTimer = setTimeout(() => el.classList.remove('is-ticking'), 80);
            lastVal = val;
          }
          if (t < 1) requestAnimationFrame(step);
          else el.textContent = target;
        };
        requestAnimationFrame(step);
      }
    });
  }

  if (!window.__vmSlideshowEditorBound) {
    window.__vmSlideshowEditorBound = true;

    document.addEventListener('shopify:block:select', (e) => {
      const slideshow = e.target.closest('vm-slideshow') || e.target.querySelector('vm-slideshow');
      const slide = e.target.classList && e.target.classList.contains('vm-slide') ? e.target : e.target.querySelector('.vm-slide');
      if (slideshow && slide) {
        const idx = parseInt(slide.dataset.index, 10);
        slideshow.stopAutoplay();
        slideshow.goTo(idx);
      }
    });

    document.addEventListener('shopify:block:deselect', (e) => {
      const slideshow = e.target.closest('vm-slideshow') || (e.target.querySelector && e.target.querySelector('vm-slideshow'));
      if (slideshow && slideshow.autoplay && !slideshow.reducedMotion) slideshow.startAutoplay();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
